module.exports = __webpack_public_path__ + "static/media/20.e1bfaa3a.jpg";